import { makeStyles } from '@material-ui/core/styles';
import { GROUP_TYPES, URL_PATH } from 'components/common/constants/Constant';
import Footer from 'components/common/footer/Footer';
import Header from 'components/common/header/Header';
import jwt from 'jwt-decode';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import OpalIcon from '../../assets/icons/logo_opal.png';
import TrainLinkIcon from '../../assets/icons/TrainLink-Logo.png';
import TransportIcon from '../../assets/icons/Transport-Logo.png';
import TMC from '../../assets/icons/TMC-Logo.png';
import Card from '../../components/common/card/card';
import styles from '../editors/RoadCondition.module.scss';
import Breadcrumb from '../../components/common/breadcrumb/breadcrumb';
import { HelpOutline } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
    },
    pageMargin: {
        margin: "0 6%",
        minHeight: '480px'
    },
    marginTop: {
        marginTop: '3%'
    }
}));

const breacrumbItems = [
    {
        label: "Home",
        href: "/"
    },
    {
        label: "Avalanche Announcements"
    }
];

const Dashboard = props => {

    const classes = useStyles();
    const oidc = useSelector(state => state.oidc);
    const [annRoles, setAnnRoles] = useState([]);

    useEffect(() => {
        if (oidc.user?.access_token) {
            const user = jwt(oidc?.user?.access_token);
            const roles = user['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
            let aRoles = []
            roles.map((role) => {
                if ("DGRP_IVR_Integration_Opal" === role) {
                    aRoles.push({ role: role, imgSrc: OpalIcon, title: "Opal", cardContent: "Opal", redirectTo: "/announcements/" +URL_PATH[GROUP_TYPES.OPAL], widerLogo: false })
                }
                else if ("DGRP_IVR_Integration_TMC" === role) {
                    aRoles.push({ role: role, imgSrc: TMC, title: "Traffic Management Centre", cardContent: "Traffic Management Centre", redirectTo: "/announcements/" + URL_PATH[GROUP_TYPES.TMC], widerLogo: true })
                }
                else if ("DGRP_IVR_Integration_TrainLink" === role) {
                    aRoles.push({ role: role, imgSrc: TrainLinkIcon, title: "NSW TrainLink", cardContent: "NSW TrainLink", redirectTo: "/announcements/" + URL_PATH[GROUP_TYPES.TRAIN_LINK], widerLogo: true })
                }
                else if ("DGRP_IVR_Integration_Transport" === role) {
                    aRoles.push({ role: role, imgSrc: TransportIcon, title: "Transport", cardContent: "Transport", redirectTo: "/announcements/" + URL_PATH[GROUP_TYPES.TRANSPORT], widerLogo: true })
                }
                return role;
            });
            setAnnRoles(aRoles);

        }
    }, [oidc.user.access_token])
    return (
        <div>
            <Header />

            <div className={classes.pageMargin}>
                <Breadcrumb items={breacrumbItems}></Breadcrumb>
                <a title="Help" className={styles.helpIcon} target="_blank" href={process.env.REACT_APP_BASE_URL + "/help/transport-ivr-messaging-application-help-avalanche-08062021/content/index.html"}>
                    <HelpOutline className="icon" style={{ fontSize: "30px" }}/>
                </a>
                <ToastContainer className={styles.toastContainer} />

                <div className={styles.mb2}>
                    {annRoles[0] &&
                        <Card title={annRoles[0].title}
                            imgSrc={annRoles[0].imgSrc}
                            cardContent={annRoles[0].cardContent}
                            widerLogo={annRoles[0].widerLogo}
                            handleClick={() => { props.history.push(annRoles[0].redirectTo) }}
                        />}
                    {annRoles[1] &&
                        <Card title={annRoles[1].title}
                            imgSrc={annRoles[1].imgSrc}
                            cardContent={annRoles[1].cardContent}
                            widerLogo={annRoles[1].widerLogo}
                            handleClick={() => { props.history.push(annRoles[1].redirectTo) }}
                        />
                    }

                    {annRoles[2] &&
                        <Card title={annRoles[2].title}
                            imgSrc={annRoles[2].imgSrc}
                            cardContent={annRoles[2].cardContent}
                            widerLogo={annRoles[2].widerLogo}
                            handleClick={() => { props.history.push(annRoles[2].redirectTo) }}
                        />
                    }
                    {annRoles[3] &&
                        <Card title={annRoles[3].title}
                            imgSrc={annRoles[3].imgSrc}
                            cardContent={annRoles[3].cardContent}
                            widerLogo={annRoles[3].widerLogo}
                            handleClick={() => { props.history.push(annRoles[3].redirectTo) }}
                        />
                    }
                </div>

            </div>
            <div className={classes.marginTop}>
                <Footer />
            </div>
        </div>
    );
}

export default withRouter(props => <Dashboard {...props} />);